import React from 'react';
import { FormattedMessage } from 'react-intl';
import Overlay from '../../shared/Overlay';
import { Helmet } from 'react-helmet-async';
import AccessControl from '../../../AccessControl';
import permissions from '../../../permissionsList';
import { cancelText } from '../../shared/SharedInternationalizations';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button, {
  buttonTypes,
  buttonSizes,
  buttonTextSizes,
} from '../../shared/Button';
import { connect } from 'react-redux';
import { exportUnits } from '../../../redux/actions/unitActions';

function UnitsExport(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const { state = {} } = location;
  const previous = state.previous || '/units/';

  function triggerExport() {
    props.dispatch(exportUnits(triggerDownload, navigate, previous));
  }

  function triggerDownload(file) {
    const today = new Date();
    let month = today.getUTCMonth() + 1;
    if (month < 10) {
      month = `0${month}`;
    }
    const nameString =
      'units' + today.getFullYear() + month + today.getUTCDate() + '.csv';
    const data = new Blob([file], { type: 'text/csv' });
    const csvURL = window.URL.createObjectURL(data);
    //window.open(csvURL);

    const tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', nameString);
    tempLink.click();
  }

  return (
    <Overlay
      rootUrl={previous}
      canClose={true}
      data-test="units-export-overlay">
      <FormattedMessage
        id="unitsExport.browserTabInfo"
        defaultMessage="Units | Export"
        description="Done button">
        {(txt) => (
          <Helmet>
            <title>{txt}</title>
          </Helmet>
        )}
      </FormattedMessage>
      <div className="content-container content-container--column">
        <FormattedMessage
          id="unitsExport.exportUnitsTitle"
          defaultMessage="Export Units"
          description="The title for the page to edit a unit"
          data-test="form-header">
          {(txt) => (
            <h1 className="no-margin text-center" data-test="form-header-text">
              {txt}
            </h1>
          )}
        </FormattedMessage>
        <hr />
        <AccessControl
          data-test="access-control"
          permissionMessage={true}
          feature={permissions.static.units.exportUnits}>
          <div className="width-100">
            <p>
              <FormattedMessage
                id="unitsExport.exportUnitsInfoText"
                defaultMessage=" Exporting units can be helpful for transferring data to other systems or for record-keeping. To export units, click the 'Export Units' button below and you will be prompted to save a CSV of all of your unit data."
                description="Opens editing something"
              />
            </p>

            <div className="form__section-container form__section-container--spread margin-bottom-25">
              <div className="form__items-group-container" />
              <div className="form__items-group-container">
                <Link
                  className="link link-text"
                  to={previous}
                  data-test="units-export-form-cancel-link">
                  {cancelText}
                </Link>

                <Button
                  onClick={triggerExport}
                  text={
                    <FormattedMessage
                      id="unitsExport.exportUnitsText"
                      defaultMessage="Export Units"
                      description="Opens editing something"
                    />
                  }
                  buttonType={buttonTypes.success}
                  buttonSize={buttonSizes.small}
                  buttonTextSize={buttonTextSizes.mediumSmall}
                  additionalStyles="no-margin margin-left-15 js-export-submit"
                  data-test="submit-button"
                />
              </div>
            </div>
          </div>
        </AccessControl>
      </div>
    </Overlay>
  );
}

export default connect()(UnitsExport);
